module.exports = "<div><markdown class=\"markdown\">{{content}}</markdown></div>"